<script lang="ts">
export default {
  name: 'CompaniesDashboardsBenefits',
}
</script>
<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { KkLoading, KkButton } from '../../../../components/base'
import { KkIndexCard } from '../../../../domains/benefits'
import type { Benefit } from '../../../../new_stores/pages/benefits/modules'
import { randomSelect } from '../../../../modules/arrayUtils'

const { t } = useI18n()
const route = useRoute()

const currentCompanyUuid = computed<string>(() => route.params.company_uuid as string)

const randomSelectedBenefits = computed(() => {
  return randomSelect(props.benefits, 3)
})

type Props = {
  benefits: Benefit[]
  loading: boolean
}

const props = defineProps<Props>()

</script>

<template>
  <section class="p-box">
    <header class="p-box__header">
      <h3 class="p-box__title">
        {{ t('pages.CompaniesDashboards.recommendedBenefits.title') }}
      </h3>
    </header>
    <div class="p-box__body">
      <KkLoading v-if="loading" />
      <div v-else-if="randomSelectedBenefits.length">
        <div class="cardContainer">
          <router-link
            v-for="(benefit, index) in randomSelectedBenefits"
            :key="index"
            class="cardLink"
            :to="{ name: 'CompaniesBenefitsDetail', params: { benefit_id: benefit.id }}"
          >
            <KkIndexCard
              :benefit="benefit"
            />
          </router-link>
        </div>
        <div class="buttons">
          <KkButton
            color="primary"
            :text="$t('labels.viewMore')"
            :to="{ name: 'CompaniesBenefitsIndex', params: { company_uuid: currentCompanyUuid }}"
          />
        </div>
      </div>
      <div v-else>
        {{ t('pages.CompaniesDashboards.recommendedBenefits.noRecommendation') }}
      </div>
    </div>
  </section>
</template>
<style lang="scss" scoped>
.cardContainer {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 576px) {
    grid-template-columns: repeat(1, 1fr);
  }
}
.cardLink {
  text-decoration: none;
}

.buttons {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
